// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   En-tête
   ========================================= */

.thema-list-header {
    display: flex;
    align-items: center;

    width: 100%;
    height: 24px;
    font-size: 12px;
    box-sizing: border-box;

    gap: 8px;
}


/* espace réservé à l'image */
.thema-header-image {
    flex: 0 0 40px;
}


/* Titre au-dessus de la combobox */
.thema-header-iptc {
    flex: 1 1;
    min-width: 0;
    color: #808080;
    text-align: center;

 
}


/* Titre au-dessus de la confidence */
.thema-header-confidence {
    flex: 0 0 35px;
    color: #808080;
    text-align: center;

 
}


/* espace réservé au bouton X */
.thema-header-delete {
    flex: 0 0 30px;
}


.thema-list {
    width: 100%;
}


.thema-list-add {
    width: 100%;
    height: 32px;

    margin-top: 4px;

    border: none;
    background: transparent;

    color: #9292ff;

    font-size: 22px;
    line-height: 30px;

    cursor: pointer;
}


.thema-list-add:hover {
    background: rgba(146, 146, 255, 0.10);
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/themalist.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;;IAEtB,QAAQ;AACZ;;;AAGA,6BAA6B;AAC7B;IACI,cAAc;AAClB;;;AAGA,mCAAmC;AACnC;IACI,SAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;;;AAGtB;;;AAGA,qCAAqC;AACrC;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;;;AAGtB;;;AAGA,+BAA+B;AAC/B;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,YAAY;;IAEZ,eAAe;;IAEf,YAAY;IACZ,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;IACf,iBAAiB;;IAEjB,eAAe;AACnB;;;AAGA;IACI,qCAAqC;AACzC","sourcesContent":["/* =========================================\n   En-tête\n   ========================================= */\n\n.thema-list-header {\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    height: 24px;\n    font-size: 12px;\n    box-sizing: border-box;\n\n    gap: 8px;\n}\n\n\n/* espace réservé à l'image */\n.thema-header-image {\n    flex: 0 0 40px;\n}\n\n\n/* Titre au-dessus de la combobox */\n.thema-header-iptc {\n    flex: 1 1 0;\n    min-width: 0;\n    color: #808080;\n    text-align: center;\n\n \n}\n\n\n/* Titre au-dessus de la confidence */\n.thema-header-confidence {\n    flex: 0 0 35px;\n    color: #808080;\n    text-align: center;\n\n \n}\n\n\n/* espace réservé au bouton X */\n.thema-header-delete {\n    flex: 0 0 30px;\n}\n\n\n.thema-list {\n    width: 100%;\n}\n\n\n.thema-list-add {\n    width: 100%;\n    height: 32px;\n\n    margin-top: 4px;\n\n    border: none;\n    background: transparent;\n\n    color: #9292ff;\n\n    font-size: 22px;\n    line-height: 30px;\n\n    cursor: pointer;\n}\n\n\n.thema-list-add:hover {\n    background: rgba(146, 146, 255, 0.10);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
